import { render, staticRenderFns } from "./Design2.vue?vue&type=template&id=6162ba54&scoped=true"
import script from "./Design2.vue?vue&type=script&lang=js"
export * from "./Design2.vue?vue&type=script&lang=js"
import style0 from "./Design2.vue?vue&type=style&index=0&id=6162ba54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6162ba54",
  null
  
)

export default component.exports